class BingAdsTracker {
  /**
   *
   * @description 加入购物车
   * @param {Object} item 加入购物车的产品
   *
   */
  addToCart = ({ value, currency }) => {
    try {
      window.uetq_2997 = window.uetq_2997 || [];
      window.uetq_2997.push('event', '', { 'revenue_value': value, 'currency': currency });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 加入购物车
   * @param {Object} item 加入购物车的产品
   *
   */
  purchase = ({ value, currency }) => {
    try {
      window.uetq_2997 = window.uetq_2997 || [];
      window.uetq_2997.push('event', '', { 'revenue_value': value, 'currency': currency });
    } catch (e) {
      console.log(e);
    }
  };
}

const bingAdsTracker = new BingAdsTracker();
export default bingAdsTracker;
